import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

export class AdminRoleRoute extends RouteBase {
  prefix = 'admin.roles.'

  rolesSearch() {
    return this.ziggyRoute('search')
  }
}
